/* global axios */
import ApiClient from './ApiClient';

// DEBT customization — transcrição de áudio pedida por um humano, no áudio que
// ele está olhando.
//
// Chaveado pelo ANEXO, e não pela conversa: o chip de áudio é um componente
// folha e não conhece o display_id da conversa. O servidor resolve a conversa a
// partir do anexo e aplica a mesma autorização por objeto — ver
// Api::V2::Accounts::Debt::AudioTranscriptionsController.
class DebtAudioTranscriptionApi extends ApiClient {
  constructor() {
    super('debt/audio_transcriptions', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  // POST porque cria trabalho (CPU do sidecar e uma unidade do teto diário);
  // um GET convidaria prefetch do navegador sobre operação que consome recurso.
  request(attachmentId) {
    return axios.post(`${this.url}/${attachmentId}`);
  }

  show(attachmentId) {
    return axios.get(`${this.url}/${attachmentId}`);
  }
}

export default new DebtAudioTranscriptionApi();
